import React, { useRef, useContext } from 'react';
import { DropTarget } from 'react-dnd';

import { ThemeContext } from '../../../ThemeContext';
import { prefix_bcs } from '../../../config';
import EmptyCanvas from './EmptyCanvas';

const getStyle = (bodyText) => {
    return {
        border: `2px dashed ${bodyText}`,
    };
};

const DnDTarget = (props) => {
    const { connectDropTarget, children, type } = props;
    const elementRef = useRef(null);
    connectDropTarget(elementRef);
    const { bodyText } = useContext(ThemeContext);

    if (type === 'page') {
        return <EmptyCanvas>{children}</EmptyCanvas>;
    } else {
        return (
            <div
                ref={elementRef}
                style={getStyle(bodyText)}
                className={prefix_bcs}
            >
                {children}
            </div>
        );
    }
};

export default DropTarget(
    (props) => props.type,
    {
        hover(props, monitor) {
            const sourceItem = monitor.getItem();
            const source = {
                index: sourceItem.index,
                parent: sourceItem.parentAddress,
            };
            const destination = {
                index: props.index || 0,
                parent: props.parentAddress,
            };
            // Don't replace items with themselves
            if (
                source.parent === destination.parent &&
                source.index === destination.index
            ) {
                return;
            }
            props.onDragItem({ source, destination });
            monitor.getItem().index = destination.index;
            monitor.getItem().parentAddress = destination.parent;
        },
        // drop: hover
    },
    (connect) => ({
        connectDropTarget: connect.dropTarget(),
    })
)(DnDTarget);
